import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form, Button } from "react-bootstrap";

import Card from "../../components/Card";
import UserService from "../../services/user/UserService";
import DataTable from "react-data-table-component";

const Unit = () => {
    const columns = [
        {
            name: 'Kode UPT',
            cell: row => row['kdUnit'],
            grow: 0.1
        },
        {
            name: 'Nama UPT',
            cell: row => row['nmUnit']
        },
        {
            name: 'Alamat UPT',
            cell: row => row['alamatUnit']
        },
        {
            name: 'Nama Inggris',
            cell: row => row['nmInggris']
        },
        {
            name: 'Nama Baru',
            cell: row => row['nmUnitBaru']
        }
    ]

    let userService = useMemo(() => new UserService(), [])

    const [listUpt, setlistUpt] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistUpt = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await userService.listUpt(null, page, size)
            setlistUpt(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistUpt([])
        }
        setLoading(false)
    }, [userService])

    useEffect(() => {
        getlistUpt(0, 10)
    }, [getlistUpt])

    const handleChangePage = (page) => {
        getlistUpt(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await userService.listUpt(null, page - 1, size)
        setlistUpt(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama UPT</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNib" placeholder="Nama UPT" className="form-control-sm" />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" >Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm">Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Unit Pelaksana Teknis</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listUpt}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Unit;
